import { render, staticRenderFns } from "./SendFuneralCeremonyNotice.vue?vue&type=template&id=99a2121c"
import script from "./SendFuneralCeremonyNotice.vue?vue&type=script&lang=js"
export * from "./SendFuneralCeremonyNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports